@if (person) {
    <adapt-catchups-page-content [person]="person"></adapt-catchups-page-content>
}
